import { Flex } from "antd";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const LayoutPublic = () => {
  return (
    <LayoutPublicWrapper>
      <Content>
        <Outlet />
      </Content>
    </LayoutPublicWrapper>
  );
};

export default LayoutPublic;

const LayoutPublicWrapper = styled(Flex)`
  width: 100vw;
  min-height: 100vh;
  background-color: #f7fafc;
  justify-content: center;
`;

const Content = styled(Flex)`
  width: 100%;
  max-width: 1200px;
  padding: 24px 16px;
  margin: auto;
  flex-direction: column;
`;
